import React , {useState,useEffect} from 'react'
import { Card, CardContent, Grid,Typography, TextField, Select, MenuItem, Checkbox, Radio, FormControlLabel, Button, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AccountCircle, Email, Phone, Add,Remove,LocationOn, VerifiedUserOutlined, Lock, DateRange, FormatListNumbered, Person } from '@mui/icons-material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import { COLORS } from '../colors';
import api from '../../Services/api';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Link ,useNavigate} from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import Autorenew from '@mui/icons-material/Autorenew';







const useStyles = makeStyles({
 

  detail: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    
    marginTop:15,
 
    
  },
  
  textField: {
    width: '80%',
    '& .MuiInputLabel-root': {
      color: 'gray', // Default label color (or set to something else)
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'gray', // Outline color to white when not focused
      },
      '&:hover fieldset': {
        borderColor: 'gray', // Optional: Outline color on hover
      },
      '&.Mui-focused fieldset': {
        borderColor: 'black', // Optional: Outline color when focused
      },
      
      
    },
   
    // When the field is focused, change label color to white
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'gray',
    },
    // Text inside input area when focused
    '& .MuiOutlinedInput-input': {
      color: 'black', // Text color inside the input area when focused
    },
    // Ensure the text inside is visible when the field is not focused
    '& .MuiOutlinedInput-input.Mui-focused': {
      color: 'black', // Make text black when focused to keep it visible
    },
  },
  
  
});

const statesInIndia = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Ladakh', 'Lakshadweep', 'Puducherry'];

const AdminCorporate = () => {

      const classes = useStyles();
      const [formData, setFormData] = useState({
     
        CorporateName: '',
        CorporatePhone: '',
        CorporatePhone1: '',
        CorporateEmail: '',
        CorporateEmail1: '',
        CorporateAddress: '',
        CorporateState: '',
        type: 'corporate',
        CorporateUserId:'' ,
        CorporatePassword: ''
    
      });

 const navigate=useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const [errors, setErrors] = useState({});


  const [extraEmailCorporateVisible, setExtraEmailCorporateVisible] = useState(false);
  const [extraPhoneNumberCorporateVisible, setExtraPhoneNumberCorporateVisible] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');

const generatePassword = ( length = 12 ) => {
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const number = '0123456789';
  const special = '!@#$%^&*()_+[]{}|;:,.<>?';
  const all = lower + upper + number + special;

  if (length < 8) throw new Error("Password length must be at least 8");

  const getRandomChar = (charset) =>
    charset.charAt(Math.floor(Math.random() * charset.length));

  // Ensure at least one from each required set
  let password = [
    getRandomChar(lower),
    getRandomChar(upper),
    getRandomChar(number),
    getRandomChar(special)
  ];

  // Fill the rest with random characters from all allowed sets
  for (let i = password.length; i < length; i++) {
    password.push(getRandomChar(all));
  }

  // Shuffle the result to avoid predictable order
  return password
    .sort(() => 0.5 - Math.random())
    .join('');
};


const handleGeneratePassword = () => {
    const newPassword = generatePassword();
    handleChange({ target: { name: 'CorporatePassword', value: newPassword } });
  };


const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleAddEmailCorporate = () => {
    setExtraEmailCorporateVisible(prevState => !prevState);
  };

  const handleAddPhoneNumberCorporate = () => {
    setExtraPhoneNumberCorporateVisible(prevState =>!prevState);
  };

 

  

  const handleChange = (event) => {
    const { name, value } = event.target;
  
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  
    // Validate just that field live
    const error = validateField(name, value);
    setErrors(prev => ({
      ...prev,
      [name]: error,
    }));
  };
  

  //VALIDATION
  const validateField = (name, value) => {
    const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/;
    const phonePattern = /^[6-9]\d{9}$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[^\s]{8,12}$/;
  
    switch (name) {
      case 'CorporateName':
        if (!value.trim()) return 'Company Name is required';
        return '';
  
      case 'CorporateState':
        if (!value) return 'State is required';
        return '';
  
      case 'CorporateAddress':
        if (!value.trim()) return 'Address is required';
        return '';
  
      case 'CorporatePhone':
        if (!value) return 'Contact number is required';
        if (!phonePattern.test(value)) return 'Invalid contact number, must start with 6-9 and length should be 10 digits';

        return '';
  
      case 'CorporateEmail':
        if (!value) return 'Email address is required';
        if (!emailPattern.test(value)) return 'Invalid email address (e.g., text@email.com)';
        return '';
  
      case 'CorporateEmail1':
        if (value && !emailPattern.test(value)) return 'Invalid email address (e.g., text@email.com)';
        return '';
  
      case 'CorporatePhone1':
        if (value && !phonePattern.test(value)) return 'Invalid Contact number. Must start with 6-9 and length should be 10 digits';
        return '';
  
      case 'CorporateUserId':
        if (!value.trim()) return 'Username is required';
        return '';
  
      case 'CorporatePassword':
        if (!value) return 'Password is required';
        if (!passwordRegex.test(value)) {
          return 'Password must be 8–12 characters long, include uppercase, lowercase, number, special character, and no spaces';
        }
        return '';
  
      default:
        return '';
    }
  };
  
  const validateForm = () => {
    const newErrors = {};
  
    Object.keys(formData).forEach((fieldName) => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
        newErrors[fieldName] = error;
      }
    });
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ returns true if no errors
  };
  



   //CREATING CLIENT PROFILE
   const handleSave = async () => {
    const isValid = validateForm();
  if(isValid){
      let data = sessionStorage.getItem('user');
      let data1 = JSON.parse(data);
      let type = data1.type;
     
      try {
        if (type === 'admin'){
       const response =  await api.Corporate.CreateCorporate(formData)
          if (response.status === 404) {
            
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message)
          }
          else if(response.status === 400){
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message)
          }
          else if(response.status === 500){
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
          }
         else if (response.status === 201) {
            const corporateData = response.data;
            sessionStorage.setItem('client', JSON.stringify(corporateData));

            setSnackbarOpen(true);
            setSnackbarMessage("Company Created Succesfully");
            
            setFormData({
            
                CorporateName: '',
                CorporatePhone: '',
                CorporatePhone1: '',
                CorporateEmail: '',
                CorporateEmail1: '',
                CorporateAddress: '',
                CorporateState: '',
                type: 'corporate',
                CorporateUserId:'' ,
                CorporatePassword: ''
            });
          
          }
          else{
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage('Error creating profile, try again')
            
          }

        
      }
      else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Only admin can create company");
        navigate('/');
            }
    }
    
   
  
        catch(error) {
          console.error('Error saving company data:', error);
         
          
        }
  }
  }
  


  return (
   <>
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            
            }}
            severity="success"
            open={snackbarOpen}
            autoHideDuration={2000}
            onClose={() => setSnackbarOpen(false)}
            sx={{
              marginTop: '2.9%', 
              marginRight: '7%'
            }}
          >
            <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            severity="error"
            open={errorSnackbarOpen}
            autoHideDuration={2000}
            sx={{
              marginTop: '2.9%', 
              marginRight: '7%'
            }}
            onClose={() => {setErrorSnackbarOpen(false)}}
          >
            <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
          </Snackbar>
          <div style={{background:'#eeee'}}>
   <h4 className="p-3  text-center " style={{borderRadius:'0px 0px 0px 0px',background: 'linear-gradient(205deg, rgba(28,28,28,1) 68%, rgba(213,214,215,0) 8%)',color:'#eeee'}}>Create Corporate Profile</h4>
<div className="mt-4">

 

    <Grid container  >

      <Grid item xs={12} sm={6}>
        <div className={classes.detail}>
          <TextField
            className={classes.textField}
            label="Corporate / Company Name"
            name="CorporateName"
            InputLabelProps={{ shrink: true }}
            value={formData.CorporateName}
            onChange={handleChange}
            error={!!errors.CorporateName}
            helperText={errors.CorporateName}
           
           
          />
        </div>

        <FormControl fullWidth sx={{marginLeft:8,marginTop:2,marginBottom:2}}>

          <InputLabel id="demo-simple-select-label">Select State</InputLabel>
          <Select
          // style={{border:'1px solid whitesmoke'}}
            className={classes.textField}
            labelId="demo-simple-select-label"
          id="demo-simple-select"
              label="Select State"
            value={formData.CorporateState}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            name="CorporateState"
            displayEmpty
            error={!!errors.CorporateState}
          >
          {/* <MenuItem value="" disabled>Select State</MenuItem> */}
          
            {statesInIndia.map((state, index) => (
              <MenuItem key={index} value={state}>{state}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {errors.CorporateState&& (
            <div className="pb-2  text-center" style={{ color: 'red', fontSize: '14px' }}>
              {errors.CorporateState}
            </div>
          )}
    

        <div className={classes.detail}>
          {/* <LocationOn className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Address"
            name="CorporateAddress"
            InputLabelProps={{ shrink: true }}
            value={formData.CorporateAddress}
            onChange={handleChange}
            error={!!errors.CorporateAddress}
            helperText={errors.CorporateAddress}
          />
        </div>

        <div className={classes.detail}>
          {/* <Phone className={classes.icon} /> */}
          <TextField
              sx={{ marginLeft: '42px' }}
              className={classes.textField}
              label="Contact Number"
              name="CorporatePhone"
              InputLabelProps={{ shrink: true }}
              value={formData.CorporatePhone}
              onChange={handleChange}
              error={!!errors.CorporatePhone}
              helperText={errors.CorporatePhone}
          />
          
          <IconButton onClick={handleAddPhoneNumberCorporate} style={{ marginLeft: '5px' }} color="primary">
              {extraPhoneNumberCorporateVisible ? <Remove sx={{ color: "gray" }} /> : <Add sx={{ color: "gray" }} />}
          </IconButton>

      </div>

        {extraPhoneNumberCorporateVisible && (
          <div className={classes.detail}>
            {/* <PhoneIphoneIcon className={classes.icon} /> */}
            <TextField
              className={classes.textField}
            
              label="Alternative Contact Number"
              name="CorporatePhone1"
              InputLabelProps={{ shrink: true }}
              value={formData.CorporatePhone1}
              onChange={handleChange}
              error={!!errors.CorporatePhone1}
              helperText={errors.CorporatePhone1}
            />
          </div>
        )}
     

        <div className={classes.detail}>
          {/* <Email className={classes.icon} /> */}
          <TextField
          sx={{marginLeft:'42px'}}
            className={classes.textField}
            label="Email"
            InputLabelProps={{ shrink: true }}
            name="CorporateEmail"
            value={formData.CorporateEmail}
            onChange={handleChange}
            error={!!errors.CorporateEmail}
            helperText={errors.CorporateEmail}
          />
         <IconButton onClick={handleAddEmailCorporate} style={{ marginLeft: '5px' }} color="primary">
              {extraEmailCorporateVisible ? <Remove sx={{ color: "gray" }} /> : <Add sx={{ color: "gray" }} />}
          </IconButton> 
        </div>

        {extraEmailCorporateVisible && (
          <div className={classes.detail}>
            {/* <MailOutlineIcon className={classes.icon} /> */}
            <TextField
              className={classes.textField}
              type="email"
              label="Alternative Email"
              name="CorporateEmail1"
              InputLabelProps={{ shrink: true }}
              value={formData.CorporateEmail1}
              onChange={handleChange}
              error={!!errors.CorporateEmail1}
              helperText={errors.CorporateEmail1}
            />
          </div>
        )}

      </Grid>

      {/* Contractor Details Column */}
      <Grid item xs={12} sm={6}  >
    

        <div className={classes.detail}>
          {/* <AccountCircle className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Username"
            name="CorporateUserId"
            InputLabelProps={{ shrink: true }}
            value={formData.CorporateUserId}
            onChange={handleChange}
            error={!!errors.CorporateUserId}
            helperText={errors.CorporateUserId}
            autoComplete="off" 
          />
        </div>

        <div className={classes.detail}>
          {/* <Lock className={classes.icon} /> */}
          <FormControl sx={{ width: '100%' }} >
            <TextField
            sx={{marginLeft:'10%'}}
              className={classes.textField}
              id="outlined-adornment-password"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff sx={{color:'black'}}/> : <Visibility sx={{color:'black'}} />}
                    </IconButton>
                     <Tooltip title="Generate Password">
                          <IconButton
                          aria-label="generate password"
                          onClick={handleGeneratePassword}
                        edge="end"
                       >
                         <Autorenew sx={{ color: 'grey' }} />
                     </IconButton>
                      </Tooltip>
                  </InputAdornment>
                ),
              }}
              label="Password"
              name="CorporatePassword"
              value={formData.CorporatePassword}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              error={!!errors.CorporatePassword}
              helperText={errors.CorporatePassword}
              autoComplete="off" 
            />
          </FormControl>
        </div>
      </Grid>
      <Grid item xs={12}>
    <button type="button" className="btn  btn-success float-end" style={{marginRight:'59px'}}  onClick={handleSave}>
        Create
      </button>
    </Grid>
    </Grid>

   
 
  </div>




    </div>
          </>
  )
}

export default AdminCorporate
